import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

import guest from './middleware/Guest';
import auth from './middleware/Auth';
import hasActiveSubscription from './middleware/HasActiveSubscription';

import Login from './views/auth/Login.vue';
import RequestResetPassword from './views/auth/ResetPassword/ResetPasswordRequest.vue';
import ResetPassword from './views/auth/ResetPassword/ResetPassword.vue';
import Dashboard from './views/Dashboard.vue';
import HeaderNavigation from './views/HeaderNavigation.vue';
import IconSidebarNav from './views/IconSidebarNav.vue';
import UserProfile from './views/account/UserProfile.vue';
import AdvertisterPerformance from './views/AdvertisterPerformance.vue';
import DomainPerformance from './views/DomainPerformance.vue';
import SubIdPerformance from './views/SubIdPerformance.vue';
import CustomSubIdPerformance from './views/CustomSubIdPerformance.vue';
import DescriptionPerformance from './views/DescriptionPerformance.vue';
import Transactions from './views/Transactions.vue';
import Help from './views/Help.vue';
import Website from './views/media/Website.vue';
import ListNetworks from './views/network/ListNetworks.vue';
import Integration from './views/integrations/Integration.vue';
import ApiAccess from './views/account/ApiAccess.vue';
import ConnectNetwork from './views/network/ConnectNetwork.vue';
import Invoice from './views/account/Invoice.vue';
import Billing from './views/account/Billing.vue';
import BillingAddress from './views/account/BillingAddress.vue';
import PaymentMethod from './views/account/PaymentMethod.vue';
import UpdatePaymentInfo from './views/account/UpdatePaymentInfo.vue';
import AddDomain from './views/media/add/AddDomain.vue';
import Agreements from './views/account/Agreements.vue';
import Snippet from './views/media/add/Snippet.vue';
import Tag from './views/account/Tag.vue';
import AffiliateLink from './views/media/add/AffiliateLink.vue';
import AddIntergration from './views/media/add/AddIntergration.vue';
import SubId from './views/media/add/SubId.vue';
import Cloaked from './views/media/add/Cloaked.vue';
import FunnelReport from './views/FunnelReport.vue';
import PageReport from './views/PageReport.vue';
import PageReportView from './views/PageReportView.vue';
import UTMBuilder from './views/tools/utm-tag-builder/index.vue';
import Users from './views/account/Users';
import GoogleOAuthLoading from './components/integrations/google-analytics-oauth/GoogleOAuthLoading.vue'
import ReactivateSubscription from "@/views/account/ReactivateSubscription";
import GoogleOAuthConnect from "@/components/integrations/google-analytics-oauth/oauth/GoogleOAuthConnect.vue";
import ConnectGoogleIntegrationV4 from "@/views/integrations/ga4/connect.vue";
import ReconnectGoogleIntegrationV4 from "@/views/integrations/ga4/reconnect.vue";
import GoogleIntegrationV4Settings from "@/views/integrations/ga4/settings.vue";
import DaisyconOauthConnectNetwork from "@/components/daisycon-oauth/DaisyconOauthConnectNetwork.vue";
import UpdateNetwork from "@/views/network/UpdateNetwork.vue";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    history: true,
    base: process.env.BASE_URL,
    linkActiveClass: 'active',
    linkExactActiveClass: 'exact-active',
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: '/',
            redirect: '/dashboard',
        },
        {
            path: '/login',
            name: 'login',
            meta: {
                layout: 'login',
                middleware: [
                    guest
                ]
            },
            component: Login,
        },
        {
            path: '/reset-password-request',
            name: 'resetPasswordRequest',
            meta: {
                layout: 'login',
                middleware: [
                    guest
                ]
            },
            component: RequestResetPassword,
        },
        {
            path: '/reset-password',
            name: 'resetPassword',
            meta: {
                layout: 'login',
                middleware: [
                    guest
                ]
            },
            component: ResetPassword,
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/user-profile',
            name: 'user-profile',
            component: UserProfile,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/api-access',
            name: 'api-access',
            component: ApiAccess,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/tools/utm-builder',
            name: 'tools-utm-builder',
            component: UTMBuilder,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/js-snippet',
            name: 'js-snippet',
            component: Tag,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/advertisers',
            name: 'advertisers',
            component: AdvertisterPerformance,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/domains',
            name: 'domains',
            component: DomainPerformance,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/sub-id',
            name: 'sub-id',
            component: SubIdPerformance,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/custom-sub-id',
            name: 'custom-sub-id',
            component: CustomSubIdPerformance,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/description',
            name: 'description',
            component: DescriptionPerformance,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/transaction-history',
            name: 'transaction-history',
            redirect: to => {
                return { path: '/transactions' }
            },
        },
        {
            path: '/transactions',
            name: 'transactions',
            component: Transactions,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/billing',
            name: 'billing',
            component: Billing,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/billing-address',
            name: 'billing-address',
            component: BillingAddress,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/payment-method',
            name: 'payment-method',
            component: PaymentMethod,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/update-payment-info',
            name: 'update-payment-info',
            component: UpdatePaymentInfo,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/help',
            name: 'help',
            component: Help,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/network/:id',
            name: 'network',
            props: true,
            component: Website,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/network-update/:websiteId/:networkId/:accountId',
            name: 'network-update',
            props: true,
            component: UpdateNetwork,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/connect-network/:id',
            name: 'connect-network',
            component: ListNetworks,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/invoice',
            name: 'invoice',
            component: Invoice,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/connect-integration/:id',
            name: 'connect-integration',
            props: true,
            component: Integration,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/connect-network/:websiteId/:networkId',
            name: 'connect-network',
            component: ConnectNetwork,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/add-network/connect/:websiteId/:networkId',
            name: 'connect',
            component: ConnectNetwork,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/add-domain',
            name: 'add-domain',
            component: AddDomain,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/snippet/:id',
            name: 'snippet',
            component: Snippet,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/add-network/:id',
            name: 'add-network',
            component: ListNetworks,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/agreement',
            name: 'agreement',
            component: Agreements,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/affiliate-link/:id',
            name: 'affiliate-link',
            component: AffiliateLink,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/add-intergration/:id',
            name: 'add-intergration',
            component: AddIntergration,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/sub-ids/:id',
            name: 'sub-ids',
            component: SubId,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/cloaked/:id',
            name: 'cloaked',
            component: Cloaked,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/header-navigation',
            name: 'header-navigation',
            meta: { layout: 'header-navigation' },
            component: HeaderNavigation,
        },
        {
            path: '/icon-sidebar-nav',
            name: 'icon-sidebar-nav',
            meta: { layout: 'icon-sidebar' },
            component: IconSidebarNav,
        },
        {
            path: '/funnel-report',
            name: 'funnel-report',
            component: FunnelReport,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/google-oauth',
            name: 'google-oauth',
            component: GoogleOAuthConnect,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/users',
            name: 'users',
            component: Users,
            props: true,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/page-report',
            name: 'page-report',
            component: PageReport,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/page-report/:id',
            name: 'page-report-view',
            component: PageReportView,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription,
                ]
            }
        },
        {
            path: '/subscription/reactivate',
            name: 'subscription-reactivate',
            component: ReactivateSubscription,
            props: false,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/:websiteId/integrations/google-analytics-v4/connect',
            name: 'connect-google-analytics-v4',
            component: ConnectGoogleIntegrationV4,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription
                ]
            }
        },
        {
            path: '/:websiteId/integrations/google-analytics-v4/reconnect',
            name: 'reconnect-google-analytics-v4',
            component: ReconnectGoogleIntegrationV4,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription
                ]
            }
        },
        {
            path: '/:websiteId/integrations/google-analytics-v4',
            name: 'google-analytics-v4',
            component: GoogleIntegrationV4Settings,
            props: true,
            meta: {
                middleware: [
                    auth,
                    hasActiveSubscription
                ]
            }
        },
        {
            path: '*',
            redirect: '/errors',
        },
    ],
});

export default router;
